(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('DivisionSearch', DivisionSearch);

    DivisionSearch.$inject = ['$resource'];

    function DivisionSearch($resource) {
        var resourceUrl =  'api/_search/divisions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
